import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import PenaltyDataTable from "./PenaltyDataTable";
import { closePenaltyModal, fetchPenalty, openPenaltyModal } from "./store/penaltySlice";
import AddPenalty from "./AddPenalty";

const Penalty = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.penaltyData || {});

  useEffect(() => {
    dispatch(fetchPenalty());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Penalty "
            title="Dashboard"
            subtitle="Penalty"
            name="Import Penalty"
            onAddClick={() => dispatch(openPenaltyModal())}
          />

          <PenaltyDataTable data={data} loading={loading} />

          <AddPenalty
            show={isModalOpen}
            onClose={() => dispatch(closePenaltyModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default Penalty;
